import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  actions: {
    getAdsList() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      const userCountry = userData?.country || 'JO'
      return axiosIns.get('/drivers/advertisement/list', {
        params: {
          country: userCountry,
        },
      })
    },
    deleteAd(_, { adId, screenId }) {
      return axiosIns.delete(`/drivers/advertisement/${screenId}/screen/${adId}`)
    },
    createAd(_, payload) {
      return axiosIns.post('/drivers/advertisement', payload)
    },
    updateAd(_, { adId, screen, country, rank }) {
      return axiosIns.put(`/drivers/advertisements/${adId}`, {
        screen,
        country,
        advertisement: {
          rank,
        },
      })
    },
  },
}
